// Catálogo de relación con el tomador aceptado por Innova (TITURELA).
export type InsuredRelationship =
    | 'PADRE/MADRE'
    | 'PAREJA'
    | 'HIJO/A'
    | 'OTRO_CONVIVIENTE';

export const INSURED_RELATIONSHIP_OPTIONS: Array<{ value: InsuredRelationship; label: string }> = [
    { value: 'PADRE/MADRE',    label: 'Padre/Madre'    },
    { value: 'PAREJA',    label: 'Pareja'    },
    { value: 'HIJO/A',   label: 'Hijo/a'   },
    { value: 'OTRO_CONVIVIENTE',   label: 'Otro conviviente'   }
];

// Normaliza el código de relación recibido de Innova (TITURELA) al valor canónico del catálogo.
// El backend legacy puede devolverlo con espacios de relleno o distinta caja, por lo que se
// recorta y se pasa a mayúsculas antes de compararlo; así el <select> lo preselecciona y la
// etiqueta casa en el listado. Devuelve '' si no coincide con ninguna opción conocida.
export function normalizeRelationship(code: string): InsuredRelationship | '' {
    if (!code) { return ''; }
    const normalized = code.trim().toUpperCase();
    const option = INSURED_RELATIONSHIP_OPTIONS.find(o => o.value === normalized);
    return option ? option.value : '';
}

export class InsuredDTO {

    name!: string;
    firstSurname!: string;
    lastName?: string;
    documentNumber!: string;
    email!: string;
    bornDate!: string;
    phonePrefix!: string;
    phone!: string;
    relationship!: InsuredRelationship;

}